module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-696.bbb54b05.jpg";